import { postApiFunctional } from "../../hooks/GlobalHooks";
import type {
  MtcDailyMonitoringApiResponse,
  MtcDailyMonitoringPayload,
} from "./types/mtcDailyMonitoringType";

const BASE_URL = process.env.REACT_APP_API_URL_2;

const mtcDailyMonitoringApi = {
  mtcDailyMonitoringUrl: `${BASE_URL}/mtc/dashboard/mobile/daily-monitoring/index`,

  getDailyMonitoring: async (
    payload: MtcDailyMonitoringPayload,
    signal?: AbortSignal,
  ): Promise<MtcDailyMonitoringApiResponse> => {
    return postApiFunctional<
      MtcDailyMonitoringApiResponse,
      MtcDailyMonitoringPayload
    >(mtcDailyMonitoringApi.mtcDailyMonitoringUrl, payload, signal);
  },
};

export default mtcDailyMonitoringApi;
